/* Animate content only as it enters view; never hide content or purchase controls. */
(() => {
  const motion = window.matchMedia('(prefers-reduced-motion: reduce)');
  if (!('IntersectionObserver' in window)) return;
  const seen = new WeakSet();
  const animations = new Set();
  const observer = new IntersectionObserver(entries => {
    entries.forEach(({ target, isIntersecting }) => {
      if (!isIntersecting) return;
      observer.unobserve(target);
      if (!motion.matches && !window.Shopify?.designMode && target.animate) {
        const animation = target.animate([{ opacity: .35, transform: 'translateY(18px)' }, { opacity: 1, transform: 'none' }], { duration: 650, easing: 'cubic-bezier(.2,.65,.3,1)' });
        animations.add(animation);
        animation.onfinish = () => animations.delete(animation);
      }
    });
  }, { threshold: .08 });
  const init = (scope = document) => {
    scope.querySelectorAll('.te-section,.te-mosaic,.te-story,.tc-category,.tc-card,.tc-band,.sg-band,.sg-details article,.tys-product-reviews').forEach(el => {
      if (seen.has(el)) return;
      seen.add(el);
      if (el.getBoundingClientRect().top > window.innerHeight) observer.observe(el);
    });
  };
  init();
  document.addEventListener('shopify:section:load', event => init(event.target));
  motion.addEventListener('change', () => { if (motion.matches) animations.forEach(animation => animation.finish()); });
})();
